import { getStorage } from '../storage';
import { ACCESS_TOKEN, PROJECT } from '../../store/types';
import { PATH_CONFIG } from '../../router/paths';


// 上传文件到服务器
function sendFile(file, fileName = file.name) {
  // const formData = new FormData();
  // formData.append('file', file, fileName);

  // fetch('/upload', {
  //     method: 'POST',
  //     body: formData,
  // })
  // .then(response => response.json())
  // .then(data => {
  //     document.getElementById('message').textContent = '上传成功';
  // })
  // .catch(error => {
  //     document.getElementById('message').textContent = '上传失败';
  //     console.error('上传失败:', error);
  // }); 
};

/**
 * 获取文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
// eslint-disable-next-line consistent-return
export const getFileAccessHttpUrl = (avatar, str, code = 'platform', subStr) => {
  if (!subStr) subStr = 'http';
  if(!str)str = 'static'
  try {
    if (avatar && avatar.startsWith(subStr)) {
      return avatar;
    }
    if (avatar && avatar.length > 0 && avatar.indexOf('[') === -1) {
      const a = avatar.split(".");
      const type = a[a.length-1];
      if(!(type==='pdf'||type==='jpeg'||type==='png'||type==='tif'||type==='jpg')){
        str = 'static'
      }
      return `${
        process.env.REACT_APP_API_IMG_URL
      }/sys/common/${str}/${avatar}?applicationCode=${code}&token=${getStorage(ACCESS_TOKEN)}`;
    }
  } catch (err) {
    return false;
  }
};

/**
 * 設置圖片文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export const getPictureUrl = (avatar,str) => getFileAccessHttpUrl(avatar, str, PROJECT.code);


/**
 * 設置圖片文件服务访问路径
 * @param avatar
 * @param subStr
 * @returns {*}
 */
export const getImageUrl = (avatar,str) => getFileAccessHttpUrl(avatar, str);

//
export const getAssetsUrl = (url) => `${PATH_CONFIG.basename}/assets/${url}`;